import {
  FETCH_BALANCE_LEDGER_RESOLVED,
  FETCH_BALANCE_LEDGER_FAILED,
  CLEAR_BALANCE_LEDGER
} from "../ActionTypes/balanceLedger";

const initialState = {
  entries: [],
  closingBalance: [],
  currencies: [],
  customerId: null,
  pagination: {
    currentPage: 1,
    lastPage: 1,
    perPage: 50,
    total: 0
  },
  loading: false,
  error: null
};

const balanceLedgerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BALANCE_LEDGER_RESOLVED:
      return {
        ...state,
        entries: action.payload.data?.entries || [],
        closingBalance: action.payload.data?.closing_balance || [],
        customerId: action.payload.data?.customer_id || null,
        currencies: action.payload.meta?.currencies || state.currencies,
        pagination: {
          currentPage: action.payload.meta?.pagination?.current_page || 1,
          lastPage: action.payload.meta?.pagination?.total_pages || 1,
          perPage: action.payload.meta?.pagination?.per_page || 50,
          total: action.payload.meta?.pagination?.total || 0
        },
        loading: false,
        error: null
      };

    case FETCH_BALANCE_LEDGER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CLEAR_BALANCE_LEDGER:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default balanceLedgerReducer;
